import { MediaInputDtoSchema } from "@/modules/common/media/api/mediaDto"
import { MAX_65535_CHARACTERS } from "@/typings/formik"
import { ScoreDifficultyEnum, ScoreType } from "@modules/scores/scoreTypes"
import { z } from "zod"

export const ScoreSetCompletionDtoSchema = z
  .object({
    id: z.string().nullable(),
    scoreSetConfigurationId: z.string(),
    displayOrder: z.number(),
    timeCapExceeded: z.boolean().nullable(),
    score: z.number().nullable(),
    scoreAdditional: z.number().nullable(),
    scoreType: z.enum(ScoreType),
    feedback: z.string().nullable(),
  })
  .meta({ id: "ScoreSetCompletionDtoSchema" })

export type ScoreSetCompletionDto = z.infer<typeof ScoreSetCompletionDtoSchema>

/* Input DTOs */
export const MultipleSetScoreInputDtoSchema = z
  .object({
    // score: z.number().nullable(), // deprecated
    scoreValueDecimal: z.number().nullable(),
    scoreAdditionalValueDecimal: z.number().nullable(),
    difficulty: z.enum(ScoreDifficultyEnum),
    note: z.string().min(0).max(MAX_65535_CHARACTERS).nullable(),
    noteAndMediaIsVisible: z.boolean(),
    medias: z.array(MediaInputDtoSchema).nullable(),
    scoreSetCompletions: z.array(ScoreSetCompletionDtoSchema),
    personalRecord: z.boolean().nullable(),
  })
  .meta({ id: "MultipleSetScoreInputDtoSchema" })

export type MultipleSetScoreInputDto = z.infer<typeof MultipleSetScoreInputDtoSchema>
